var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GiVendorIndex',{attrs:{"pageTitle":"GI Vendor Transfer Warehouse","isCentralWarehouse":false,"commitRouteName":"outbound-delivery-transfer-warehouse-commit","order-type":_vm.orderTypeStockTransfer,"skipWarehouseSelection":true}})}
var staticRenderFns = []

export { render, staticRenderFns }